import { Component } from '@angular/core';
import { RoutingStateService } from './services/routing-state.service'
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogPolicyComponent } from './dialog-policy/dialog-policy.component';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  constructor(
    private routing: RoutingStateService,
    public dialog: MatDialog,
    private authService: AuthService,
    private router: Router // Inject the Router service
  ){
    routing.loadRouting()
    
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const showPolitica = currentUser ? currentUser.showPolitica : false;

    if (currentUser && showPolitica) {
      this.openPdfPolicy()
    }
  }

  openPdfPolicy() {
    const dialogRef = this.dialog.open(DialogPolicyComponent, {
      width: '800px',
      data: { pdfSrc: 'assets/pdf/Política de Conduta Representantes Comerciais_2024_21.04.2024.pdf' },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.authService.policyRead().subscribe(message => {
          console.log(message.msg)

          const currentUser = JSON.parse(localStorage.getItem('currentUser'));
          currentUser.showPolitica = false;
          localStorage.setItem('currentUser', JSON.stringify(currentUser));
        })
      } else {
        console.log('Falha ao aceitar a política');
      }
    });
  }
}
